const MINUTES_PER_HOUR = 60;

const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;

const CLOCK_HOUR_MINUTE_PATTERN = /^(\d{1,2}):(\d{2})$/;

const MAX_CLOCK_HOUR = 99;

const MAX_CLOCK_MINUTE = 59;

const parseHourMinuteStringToMinutes = (timeString: string): number | null => {
  const trimmed = timeString.trim();
  const matchResult = trimmed.match(CLOCK_HOUR_MINUTE_PATTERN);
  if (matchResult == null) {
    return null;
  }
  const hours = parseInt(matchResult[1], 10);
  const minutes = parseInt(matchResult[2], 10);
  if (
    !Number.isFinite(hours) ||
    !Number.isFinite(minutes) ||
    hours < 0 ||
    hours > MAX_CLOCK_HOUR ||
    minutes < 0 ||
    minutes > MAX_CLOCK_MINUTE
  ) {
    return null;
  }
  return hours * MINUTES_PER_HOUR + minutes;
};

export const minutesBetweenDepartureArrival = (
  departureTime: string | null,
  arrivalTime: string | null
): number | null => {
  if (departureTime == null || arrivalTime == null) {
    return null;
  }
  if (
    !CLOCK_HOUR_MINUTE_PATTERN.test(departureTime.trim()) ||
    !CLOCK_HOUR_MINUTE_PATTERN.test(arrivalTime.trim())
  ) {
    return null;
  }
  const departureMinutes = parseHourMinuteStringToMinutes(departureTime);
  const arrivalMinutes = parseHourMinuteStringToMinutes(arrivalTime);
  if (departureMinutes === null || arrivalMinutes === null) {
    return null;
  }
  if (arrivalMinutes >= departureMinutes) {
    return arrivalMinutes - departureMinutes;
  }
  return arrivalMinutes + MINUTES_PER_DAY - departureMinutes;
};

export const formatDurationMinutesJa = (totalMinutes: number): string => {
  const wholeHours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
  const remainderMinutes = totalMinutes % MINUTES_PER_HOUR;
  if (wholeHours <= 0) {
    return `${remainderMinutes}分`;
  }
  return remainderMinutes > 0 ? `約${wholeHours}時間${remainderMinutes}分` : `約${wholeHours}時間`;
};
